<template>
  <div
    v-if="message"
    class="form-error-banner"
    role="alert"
    data-testid="form-error-banner"
  >
    <div class="form-error-banner__icon" aria-hidden="true">
      <i class="pi pi-exclamation-circle" />
    </div>
    <pre class="form-error-banner__text">{{ message }}</pre>
    <button
      type="button"
      class="form-error-banner__dismiss"
      aria-label="Закрыть"
      data-testid="form-error-banner-dismiss"
      @click="onDismiss"
    >
      <i class="pi pi-times" aria-hidden="true" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { clearFormError, useFormError } from '@/common/utils/formErrorStore'
import { usePageData } from '@/common/composables/usePageData'

const { pageDataSlot } = usePageData()
const message = useFormError(() => pageDataSlot.value)

function onDismiss(): void {
  clearFormError(pageDataSlot.value)
}
</script>

<style scoped lang="scss">
.form-error-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0 0 0.75rem;
  padding: 0.85rem 1rem;
  border: 1px solid color-mix(in srgb, #c23b3b 35%, #e5e7eb);
  border-radius: 10px;
  background: color-mix(in srgb, #c23b3b 10%, #fff);
  color: #7a1f1f;
  box-shadow: 0 1px 2px rgb(0 0 0 / 6%);
}

.form-error-banner__icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.1rem;
  color: #b42318;
  font-size: 1.15rem;
}

.form-error-banner__text {
  flex: 1 1 auto;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.4;
}

.form-error-banner__dismiss {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  margin: -0.2rem -0.35rem 0 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #7a1f1f;
  cursor: pointer;
}

.form-error-banner__dismiss:hover {
  background: color-mix(in srgb, #c23b3b 14%, transparent);
}

.form-error-banner__dismiss:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary-color, #1e3a6e) 45%, transparent);
  outline-offset: 1px;
}
</style>
